var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.342,
    height: 19.341,
    viewBox: "0 0 19.342 19.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "send",
    d: "M17.665,7.035,3.2.228A2.222,2.222,0,0,0,.139,2.989c.014.035,3.555,6.687,3.555,6.687S.218,16.326.206,16.36a2.218,2.218,0,0,0,3.056,2.758l14.405-6.8a2.917,2.917,0,0,0,0-5.282ZM1.638,2.392a.61.61,0,0,1,.855-.713L16.981,8.494a1.321,1.321,0,0,1,.476.372H5.091ZM16.98,10.858,2.562,17.666a.61.61,0,0,1-.855-.713l3.387-6.474H17.462a1.326,1.326,0,0,1-.481.38Z",
    transform: "translate(-0.003 -0.003)",
    fill: "#ff6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.8b53e11d3a27747037878a5f8aca79a4.svg";
export { ForwardRef as ReactComponent };